import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link,  } from "react-router-dom";
import { Col } from "react-bootstrap";
import ShowSkeleton from "../utils/helpers/skeleton";
import {getStaff,editStaff} from "../store/slices/mpd";


const Staff = () => {

  const [isloading, setisLoading] = useState(false);
  const dispatch = useDispatch();

const [formData, setFormData] = useState({
  principal: "",
  totalTeachers: "",
  pgt: "",
  tgt: "",
  prt: "",
  ntt: "",
  ratio: "",
  specialEducator:"",
  counsellor:"",
});

const getInfo = () => {
  dispatch(getStaff())
    .unwrap()
    .then((response) => {
      setFormData(response?.data || {});
    })
    .catch(({ message }) => console.error(message))
    .finally(() => {
      setisLoading(false);
    });
};

useEffect(() => {
  dispatch(getStaff())
    .unwrap()
    .then((response) => {
      setFormData(response.data);
    });
}, []);

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
};


const handleSubmit = (e) => {
  e.preventDefault();

  dispatch(editStaff(formData))
    .unwrap()
    .then(() => {
      alert("Staff Information Updated");
      getInfo();
    })
    .catch((err) => {
      alert(err.message);
    });
};

  return (
    <>
     
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Staff</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Staff</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
         
        </div>
      <div className="card-body px-24 py-10">
  {isloading ? (
    <Col lg={12} xs={12} md={12} align="center">
      {ShowSkeleton()}
    </Col>
  ) : (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-20">
          <label className="form-label">Principal</label>
          <input
            type="text"
            className="form-control"
            name="principal" maxLength={100}
            value={formData.principal || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-3 mb-20">
          <label className="form-label">Total Teachers</label>
          <input
            type="text"
            className="form-control"
            name="totalTeachers" maxLength={100}
            value={formData.totalTeachers || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3 mb-20">
          <label className="form-label">Teacher Section Ratio</label>
          <input
            type="text"
            className="form-control" maxLength={30}
            name="ratio"
            value={formData.ratio || ""}
            onChange={handleChange}
          />
        </div>

        

        <div className="col-md-3 mb-20">
          <label className="form-label">PGT</label>
          <input
            type="text"
            className="form-control"
            name="pgt"
            maxLength={70}
            value={formData.pgt || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3 mb-20">
          <label className="form-label">TGT</label>
          <input
            type="text"
            className="form-control"
            name="tgt"
            maxLength={70}
            value={formData.tgt || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-3 mb-20">
          <label className="form-label">PRT</label>
          <input
            type="text" maxLength={100}
            className="form-control"
            name="prt"
            value={formData.prt || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-3 mb-20">
          <label className="form-label">NTT</label>
          <input
            type="text"
            className="form-control" maxLength={30}
            name="ntt"
            value={formData.ntt || ""}
            onChange={handleChange}
          />
        </div>
 <div className="col-md-6 mb-20">
          <label className="form-label">Special Educator</label>
          <input
            type="text"
            className="form-control"
            name="specialEducator" maxLength={100}
            value={formData.specialEducator || ""}
            onChange={handleChange}
          />
        </div>
         <div className="col-md-6 mb-20">
          <label className="form-label">Counsellor</label>
          <input
            type="text"
            className="form-control"
            name="counsellor" maxLength={100}
            value={formData.counsellor || ""}
            onChange={handleChange}
          />
        </div>
         

        <div className="col-12 mt-3">
          <button
            type="submit"
            className="btn btn-primary py-2 px-5"
          >
           Update
          </button>
        </div>
      </div>
    </form>
  )}
</div>
      </div>
    </>
  );
};

export default Staff;
